import React, { Component } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';


const Main = styled.div`
padding: 20px 10px 20px 0;
position: relative;
`;

const Header = styled.h2`
font-family: 'Dumbledor';
font-size: 10pt;
text-transform: uppercase;
margin: 0;
color: var(--botc-colour-cream-stark-white);
cursor: pointer;
`;

const ExpandButton = styled.button`
border: none;
background-color: transparent;
position: absolute;
padding: 8px;
top: 12px;
right: -4px;
color: var(--botc-colour-cream-stark-white);
`;

const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 15px;
  font-family: 'Trade Gothic LT Std';
  color: var(--botc-colour-cream-springwood);
  font-size: 16px;
`;

class RoleFilterSection extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isExpanded: !!this.props.isInitiallyExpanded,
    };

    this.handleExpandClick = this.handleExpandClick.bind(this);
  }

  handleExpandClick() {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  render() {
    return (
      <Main>
        <Header onClick={this.handleExpandClick}>{this.props.headingText}</Header>
        <ExpandButton onClick={this.handleExpandClick}>
          <span className={classNames('glyphicon', this.state.isExpanded ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down')} />
        </ExpandButton>
        {this.state.isExpanded && <ChildrenContainer>{this.props.children}</ChildrenContainer>}
      </Main>
    );
  }

}

export default RoleFilterSection;
